/* ==========================================================================
   SpotMyStuff — UGC Video Grid section
   Tap-to-play video tiles. Originally reproduced the handoff's own
   stated behavior literally — "Videos load muted, on tap only, with a
   poster image" — but per a later request, videos now play WITH sound
   (unmuted) so the phone's hardware volume buttons work and playback
   starts at whatever system volume the device is already at. Nothing
   still autoplays before it's needed: the <video> tag is rendered with
   preload="none" (see the .liquid file), so nothing is even fetched
   until a tile is tapped, and that tap is what satisfies the browser's
   autoplay-with-sound gesture requirement — this script only starts/
   stops playback and swaps the poster/play-glyph for the video visually.

   This interaction doesn't exist anywhere else in the SpotMyStuff
   sections, so it's a new, section-scoped file — but it follows the
   exact same self-contained IIFE pattern as spotmystuff-usecases.js and
   spotmystuff-problem.js (own namespace, own DOMContentLoaded guard, no
   shared state or globals), so it can't conflict with any other
   section's script.

   Tiles with no video uploaded yet (aria-disabled="true", set server-
   side in the .liquid file whenever that UGC slot's video setting is
   empty) are inert here — clicking them does nothing, since there's
   nothing to play. This keeps the section fully functional the moment a
   merchant uploads real clips through the Theme Editor, with no further
   code changes.
   ========================================================================== */

(function () {
  'use strict';

  function initTile(tile) {
    if (tile.getAttribute('aria-disabled') === 'true') return;

    var video = tile.querySelector('.spotmystuff-ugc__video');
    if (!video) return;

    // preload="none" means the browser has nothing to paint the instant
    // playback is requested — without this, there's a blank/grey box
    // for however long the video takes to fetch enough data for its
    // first frame. Giving the <video> element the SAME image already
    // shown as the tile's poster means it has something to display from
    // the very first frame of the transition, closing that gap.
    if (tile.dataset.poster) {
      video.poster = tile.dataset.poster;
    }

    function play() {
      tile.classList.add('is-playing');
      // Deliberately NOT forcing video.muted here — the <video> element
      // already renders unmuted (see the .liquid file), and on mobile
      // the actual playback volume for an unmuted video is controlled
      // by the device's hardware volume buttons / current system
      // volume, not by JS. Setting video.muted here would silence it on
      // every tap regardless of what the phone's volume is at.
      video.currentTime = 0;
      video.play();
    }

    function stop() {
      tile.classList.remove('is-playing');
      video.pause();
    }

    tile.addEventListener('click', function () {
      if (tile.classList.contains('is-playing')) return;
      play();
    });

    tile.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (!tile.classList.contains('is-playing')) play();
      }
    });

    video.addEventListener('ended', stop);

    // Native <video controls> is deliberately never turned on — on iOS
    // Safari it dims the video behind its own control chrome for a few
    // seconds after every interaction, which read as a stuck grey
    // overlay. Instead, tapping the video itself (once playing) just
    // toggles play/pause directly, with none of that native UI.
    video.addEventListener('click', function (event) {
      event.stopPropagation();
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  function init() {
    var tiles = document.querySelectorAll('[data-spotmystuff-ugc-tile]');
    tiles.forEach(initTile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
